<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Proposta Cliente</div>
  <!--  @if (checkPermission('criar')) {-->
  <div class="mr-8">
    <button mat-raised-button class="btn-add" (click)="newPriceQuote()">
      Novo
    </button>
  </div>
  <!--  }-->
</div>
<div>
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Pesquisa </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <form-search-proposal-client
            [search]="inputSearch"
            (responseSearch)="search($event)"
          />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--    }-->

    <div class="mt-6">
      @if (!loading) {
        <div>
          <table-list-proposal-page
            [spinLoad]="spinLoad"
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (viewItem)="editItem($event)"
            (replicateItem)="replicateItem($event)"
            (deleteItem)="deleteItem($event)"
            (downloadItem)="modalDownload($event)"
            (sendContract)="createContract($event)"
            (sendEmail)="sendEmail($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
